// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const defaultProps = {
  width: '13.357px',
  color: '#5badfa',
}

const propTypes = {
  width: PropTypes.string,
  color: PropTypes.string,
}

// Component
function IconPaperClipVertical({ width, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      viewBox="0 0 1024 1024"
    >
      <path
        fill={color}
        d="M704 256 704 746.666667C704 840.96 627.626667 917.333333 533.333333 917.333333 439.04 917.333333 362.666667 840.96 362.666667 746.666667L362.666667 213.333333C362.666667 154.453333 410.453333 106.666667 469.333333 106.666667 528.213333 106.666667 576 154.453333 576 213.333333L576 661.333333C576 684.8 556.8 704 533.333333 704 509.866667 704 490.666667 684.8 490.666667 661.333333L490.666667 256 426.666667 256 426.666667 661.333333C426.666667 720.213333 474.453333 768 533.333333 768 592.213333 768 640 720.213333 640 661.333333L640 213.333333C640 119.04 563.626667 42.666667 469.333333 42.666667 375.04 42.666667 298.666667 119.04 298.666667 213.333333L298.666667 746.666667C298.666667 876.373333 403.626667 981.333333 533.333333 981.333333 663.04 981.333333 768 876.373333 768 746.666667L768 256 704 256Z"
      />
    </svg>
  )
}

IconPaperClipVertical.defaultProps = defaultProps
IconPaperClipVertical.propTypes = propTypes

export default IconPaperClipVertical
